<script lang="ts">
  import type { Snippet } from 'svelte'
  import ResponseBanner from './ResponseBanner.svelte'

  let { children }: { children: Snippet } = $props()
</script>

<ResponseBanner />
{@render children()}
